import { CustomerAreaQuickActionCard, CustomerAreaSurfaceCard } from '../customer-area'

type PrivacyQuickLinksSectionProps = {
  title: string
  subtitle: string
  exportTitle: string
  exportDescription: string
  exportCta: string
  profileTitle: string
  profileDescription: string
  profileCta: string
  preferencesTitle: string
  preferencesDescription: string
  preferencesCta: string
  deleteTitle: string
  deleteDescription: string
  deleteCta: string
  onRequestExport: () => void
  onGoProfile: () => void
  onGoPreferences: () => void
  onScrollToDelete: () => void
}

export const PrivacyQuickLinksSection = ({
  title,
  subtitle,
  exportTitle,
  exportDescription,
  exportCta,
  profileTitle,
  profileDescription,
  profileCta,
  preferencesTitle,
  preferencesDescription,
  preferencesCta,
  deleteTitle,
  deleteDescription,
  deleteCta,
  onRequestExport,
  onGoProfile,
  onGoPreferences,
  onScrollToDelete,
}: PrivacyQuickLinksSectionProps) => (
  <CustomerAreaSurfaceCard title={title} subtitle={subtitle}>
    <div className="grid gap-3 md:grid-cols-2 xl:grid-cols-4">
      <CustomerAreaQuickActionCard
        title={exportTitle}
        description={exportDescription}
        ctaLabel={exportCta}
        onClick={onRequestExport}
      />
      <CustomerAreaQuickActionCard
        title={profileTitle}
        description={profileDescription}
        ctaLabel={profileCta}
        onClick={onGoProfile}
      />
      <CustomerAreaQuickActionCard
        title={preferencesTitle}
        description={preferencesDescription}
        ctaLabel={preferencesCta}
        onClick={onGoPreferences}
      />
      <CustomerAreaQuickActionCard
        title={deleteTitle}
        description={deleteDescription}
        ctaLabel={deleteCta}
        onClick={onScrollToDelete}
      />
    </div>
  </CustomerAreaSurfaceCard>
)
